if (!customElements.get('nv-header')) customElements.define('nv-header', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort(); this.controller = new AbortController();
  const opts = {signal:this.controller.signal};
  const dialog = this.querySelector('dialog');
  const opener = this.querySelector('.nv-menu-open');
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animate = async (el, frames, duration=180) => {
   if (!reduced()) try { await el.animate(frames,{duration,easing:'cubic-bezier(.2,.7,.2,1)'}).finished; } catch {}
  };
  const closeDetails = async d => {
   if (!d.open || d.dataset.closing) return;
   const closing = Symbol(); d.nvClosing = closing;
   d.dataset.closing='true';
   await animate(d.querySelector('.nv-mega'),[{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-6px)'}]);
   if(d.nvClosing !== closing) return;
   d.open=false;delete d.dataset.closing;
  };
  const closeDialog = async () => {
   if(!dialog.open || dialog.dataset.closing) return;
   dialog.dataset.closing='true';
   await animate(dialog,[{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX(24px)'}],210);
   dialog.close();delete dialog.dataset.closing;
  };
  opener.addEventListener('click', () => {
   dialog.showModal(); this.previousOverflow=document.documentElement.style.overflow;
   document.documentElement.style.overflow='hidden';opener.setAttribute('aria-expanded','true');
  },opts);
  this.querySelector('.nv-menu-close').addEventListener('click',closeDialog,opts);
  dialog.addEventListener('cancel',e=>{e.preventDefault();closeDialog();},opts);
  dialog.addEventListener('close',()=>{
   document.documentElement.style.overflow=this.previousOverflow||'';
   dialog.querySelectorAll('details[open]').forEach(d=>d.open=false);
   opener.setAttribute('aria-expanded','false');opener.focus();
  },opts);
  this.querySelectorAll('.nv-nav-back').forEach(b=>b.addEventListener('click',async()=>{
   const d=b.closest('details');await closeDetails(d);d.querySelector('summary').focus();
  },opts));
  this.querySelectorAll('details').forEach(d=>{
   let hoverTimer;
   d.addEventListener('pointerenter', e => {
    if(e.pointerType !== 'mouse' || !matchMedia('(min-width:990px) and (hover:hover)').matches) return;
    clearTimeout(hoverTimer); d.nvClosing=null; delete d.dataset.closing;
    d.querySelector('.nv-mega').getAnimations().forEach(a=>a.cancel());
    d.open=true;
   },opts);
   d.addEventListener('pointerleave', e => {
    if(e.pointerType === 'mouse' && !dialog.open) hoverTimer=setTimeout(()=>closeDetails(d),200);
   },opts);
   d.querySelector('summary').addEventListener('click',e=>{if(d.open){e.preventDefault();closeDetails(d);}},opts);
   d.addEventListener('toggle',()=>{
    if(d.open && dialog.contains(d)) dialog.scrollTop=0;
    if(d.open)d.closest('nav').querySelectorAll('details').forEach(other=>{if(other!==d)other.open=false;});
   },opts);
  });
  document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details[open]').forEach(closeDetails);},opts);
  this.addEventListener('keydown',e=>{if(e.key==='Escape'&&!dialog.open)this.querySelectorAll('details[open]').forEach(async d=>{await closeDetails(d);d.querySelector('summary').focus();});},opts);
  window.addEventListener('resize',()=>{if(dialog.open&&matchMedia('(min-width:990px)').matches)dialog.close();},opts);
 }
 disconnectedCallback(){this.controller?.abort();if(this.querySelector('dialog')?.open)document.documentElement.style.overflow=this.previousOverflow||'';}
});
